import { render } from "./GoodsTable.vue?vue&type=template&id=6dc9cc1a&scoped=true"
import script from "./GoodsTable.vue?vue&type=script&lang=js"
export * from "./GoodsTable.vue?vue&type=script&lang=js"

import "./GoodsTable.vue?vue&type=style&index=0&id=6dc9cc1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc9cc1a"]])

export default __exports__